import { ResourcePermission, UserDetail } from "../../services/endpoints"

export type SessionStorageType = {
username: string
time: number
}

export type LocalStorageUser = {
  id: string
  roles: string[]
  profile: UserDetail
  permissions: ResourcePermission[]
  administrator: boolean
  preferences: Preferences
}

export type Preferences = {
  [key: string]: {
    id: number
    val: string | number | boolean
  }
}

export type SessionData = {
  accessToken: string | null
  refreshToken: string | null
  user: LocalStorageUser | null
  session: SessionStorageType | null
  expiresAt: number | null
  expiresIn: number | null
}

export const getFromLocalStorage = (): SessionData => {
  return {
    accessToken: _getFromLocalStorageItem('wivi.access_token'),
    refreshToken: _getFromLocalStorageItem('wivi.refresh_token'),
    user: _getUserFromJson(_getFromLocalStorageItem('wivi.user')),
    expiresIn: parseInt(_getFromLocalStorageItem('wivi.expires_in') || '0') || 0,
    expiresAt: parseInt(_getFromLocalStorageItem('wivi.expires_at') || '0') || 0,
    session: _getSessionFromJson(_getFromLocalStorageItem('wivi.session'))
  }
}

export const flushToLocalStorage = (state: SessionData): void => {
  _saveOrDeleteLocalStorageItem('wivi.access_token', JSON.stringify(state.accessToken) || null)
  _saveOrDeleteLocalStorageItem('wivi.refresh_token', JSON.stringify(state.refreshToken) || null)
  _saveOrDeleteLocalStorageItem('wivi.expires_in', state.expiresIn || null)
  _saveOrDeleteLocalStorageItem('wivi.expires_at', state.expiresAt || null)
  _saveOrDeleteLocalStorageItem('wivi.session', _getJsonFromSession(state.session) || null)
  _saveOrDeleteLocalStorageItem('wivi.user', _getJsonFromUser(state.user) || null)
}  

export const _saveOrDeleteLocalStorageItem = (key: string, value: string | number | null): void => {
  if (value === null || value === 'null') window.localStorage.removeItem(key)
  else window.localStorage.setItem(key, `${value}`)
}

export const _getFromLocalStorageItem = (key: string): string | null => {
  return window.localStorage.getItem(key)
}

export const _getUserFromJson = (data: string | null): null | LocalStorageUser => {
  if (!data) return null

  //Need to run it through twice as it gets escaped by Storage.setItem()
  const user = JSON.parse(data)
  if(typeof user === 'string')
    return JSON.parse(user) //todo should force shape to ensure it's correct
  else
    return user
}

export const _getJsonFromUser = (user: LocalStorageUser | null): string | null => {
  if(!user) return null

  return JSON.stringify(user)
}

export const _getSessionFromJson = (data: string | null): null | SessionStorageType => {
  if (!data) return null

  //Need to run it through twice as it gets escaped by Storage.setItem()
  const session = JSON.parse(data)
  if(typeof session === 'string')
    return JSON.parse(session) //todo should force shape to ensure it's correct
  else
    return session
}

export const _getJsonFromSession = (user: SessionStorageType | null): string | null => {
  if(!user) return null

  return JSON.stringify(user)
}
